const descriptionLines = [
  {
    id: 1,
    styles: {
      height: '34px',
      width: '40%',
    },
  },
  {
    id: 2,
    styles: {
      height: '28px',
      width: '59%',
    },
  },
  {
    id: 3,
    styles: {
      height: '14px',
      width: '55%',
    },
  },
  {
    id: 4,
    styles: {
      height: '14px',
      width: '90%',
    },
  },
  {
    id: 5,
    styles: {
      height: '14px',
      width: '70%',
    },
  },
  {
    id: 6,
    styles: {
      height: '14px',
      width: '62%',
    },
  },
]

export default function ItineraryPlaceholder() {
  return (
    <div className='itinerary-placeholder placeholder-animation'>
      <div className='itinerary-placeholder__info'>
        <div className='itinerary-placeholder__text'>
          <div
            className='itinerary-placeholder__line'
            style={{ width: '15%', height: '16px' }}
          />
          <div
            className='itinerary-placeholder__line'
            style={{ width: '50%', height: '24px' }}
          />
        </div>
        <div
          className='itinerary-placeholder__line gray'
          style={{ width: '100%', height: '100px' }}
        />
        <div className='itinerary-placeholder__text'>
          {descriptionLines.map((item) => {
            return (
              <div
                key={item.id}
                style={item.styles}
                className='itinerary-placeholder__line'
              />
            )
          })}
        </div>
        <div
          className='itinerary-placeholder__line'
          style={{ width: '80%', height: '24px' }}
        />
        <div
          className='itinerary-placeholder__line'
          style={{ width: '90%', height: '48px' }}
        />
        <div className='itinerary-placeholder__image mbm' />
        <div className='itinerary-placeholder__text'>
          {descriptionLines.reverse().map((item) => {
            return (
              <div
                key={item.id}
                style={item.styles}
                className='itinerary-placeholder__line'
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
